/* Unified Inbox - channel / priority / intent metadata and small helpers. */
import { Mail, MessagesSquare, Linkedin, Phone, Globe, Landmark, MessageCircle, Smartphone, Flame, ArrowUp, Minus, ArrowDown, Inbox as InboxIcon, FileSearch, Repeat, LifeBuoy, Truck, Users, CalendarClock, Handshake, BellOff, Sparkles } from "lucide-react";

export const CHANNELS = {
  email: { label: "E-mail", short: "Mail", Icon: Mail, cls: "bg-[hsl(215_30%_36%)]" },
  teams: { label: "Microsoft Teams", short: "Teams", Icon: MessagesSquare, cls: "bg-[hsl(262_26%_42%)]" },
  linkedin: { label: "LinkedIn", short: "LinkedIn", Icon: Linkedin, cls: "bg-[hsl(200_48%_34%)]" },
  phone: { label: "Phone", short: "Phone", Icon: Phone, cls: "bg-[hsl(150_28%_32%)]" },
  webform: { label: "Web form", short: "Form", Icon: Globe, cls: "bg-[hsl(20_55%_46%)]" },
  tender: { label: "Tender portal", short: "Tender", Icon: Landmark, cls: "bg-[hsl(225_12%_28%)]" },
  whatsapp: { label: "WhatsApp", short: "WhatsApp", Icon: MessageCircle, cls: "bg-[hsl(145_40%_34%)]" },
  sms: { label: "SMS", short: "SMS", Icon: Smartphone, cls: "bg-[hsl(35_45%_40%)]" },
};

export const CHANNEL_ORDER = ["email", "teams", "linkedin", "phone", "webform", "tender", "whatsapp", "sms"];

export const PRIORITY = {
  urgent: { label: "Urgent", Icon: Flame, cls: "border-[hsl(var(--primary)/0.35)] bg-[hsl(var(--primary)/0.10)] text-[hsl(10_70%_42%)]" },
  high: { label: "High", Icon: ArrowUp, cls: "border-[hsl(var(--status-warn)/0.35)] bg-[hsl(var(--status-warn)/0.10)] text-[hsl(35_80%_32%)]" },
  normal: { label: "Normal", Icon: Minus, cls: "border-black/[0.08] bg-white text-muted-foreground" },
  low: { label: "Low", Icon: ArrowDown, cls: "border-black/[0.06] bg-muted text-muted-foreground" },
};

export const INTENT = {
  new_inquiry: { label: "New inquiry", Icon: Sparkles },
  rfq: { label: "Request for quote", Icon: FileSearch },
  tender: { label: "Tender", Icon: Landmark },
  follow_up: { label: "Follow-up", Icon: Repeat },
  support: { label: "Support", Icon: LifeBuoy },
  supplier: { label: "Supplier", Icon: Truck },
  internal: { label: "Internal", Icon: Users },
  scheduling: { label: "Scheduling", Icon: CalendarClock },
  partner: { label: "Partner", Icon: Handshake },
  noise: { label: "Noise", Icon: BellOff },
};

export const VIEWS = [
  { key: "focus", label: "Focus" },
  { key: "all", label: "All" },
  { key: "mine", label: "Mine" },
  { key: "unassigned", label: "Unassigned" },
  { key: "snoozed", label: "Snoozed" },
  { key: "done", label: "Done" },
];

export const EVIDENCE_KIND = { "CONFIRMED FACT": "fact", "EXTERNAL SIGNAL": "signal", "AI INFERENCE": "inference", "COMMERCIAL HYPOTHESIS": "hypothesis" };

export const LANG = { no: "Norwegian", sv: "Swedish", da: "Danish", en: "English" };

export const SENTIMENT = {
  positive: { label: "Positive", cls: "text-[hsl(var(--status-ok))]" },
  neutral: { label: "Neutral", cls: "text-muted-foreground" },
  frustrated: { label: "Frustrated", cls: "text-[hsl(var(--status-bad))]" },
};

export function dueLabel(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = (d.getTime() - Date.now()) / 86400000;
  if (diff < -0.5) return { text: `Overdue ${Math.round(-diff)}d`, tone: "bad" };
  if (diff < 0.5) return { text: "Due today", tone: "warn" };
  if (diff < 1.5) return { text: "Due tomorrow", tone: "warn" };
  return { text: `Due in ${Math.round(diff)}d`, tone: diff < 3 ? "warn" : "muted" };
}

export function channelMeta(c) {
  return CHANNELS[c] || { label: c, short: c, Icon: InboxIcon, cls: "bg-[hsl(225_12%_28%)]" };
}
